import { Row, Col } from "reactstrap";
import { H3, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { EmailTabHeadProp } from "../../../Type/EmailType";

export const EmailTabHead = ({ data }: EmailTabHeadProp) => {
  return (
    <Row>
      <Col md="6" sm="12" className="xl-100">
        <div className="d-flex">
          <Image className="me-3 rounded-circle" src={dynamicImage("user/user.png")} alt="image" />
          <div className="flex-grow-1">
            <H3>
              {data.tittle}&nbsp;&nbsp;
              <small>
                <span className="digits email-badge">{data.date}&nbsp;</span>
                {data.month}&nbsp;&nbsp;<span className="digits email-badge">6:00&nbsp;</span>AM
              </small>
            </H3>
            <P>{data.paragraph}</P>
          </div>
        </div>
      </Col>
      <Col md="6" sm="12" className="xl-100">
        <div className="float-end d-flex">
          <P className="user-emailid">
            {data.tittle.replaceAll(" ", "")}
            <span className="digits email-badge">23</span>@company.com
          </P>
          <i className="fa fa-star-o f-18 mt-1" />
        </div>
      </Col>
    </Row>
  );
};
